export const pharmacies = {
  hero: {
    title: "药房专业记账与财务管理",
    subtitle: "专为独立药房、连锁药房和配药设施设计的符合HIPAA标准的财务服务",
    cta: "预约免费咨询",
    learnMore: "了解更多"
  },
  services: {
    title: "全面的药房财务服务",
    subtitle: "从处方收入跟踪到DEA合规，我们处理您药房财务管理的各个方面",
    items: [
      {
        title: "处方收入管理",
        description: "按付款方类型（现金、保险、Medicare/Medicaid）跟踪和核对所有处方销售，自动匹配存款"
      },
      {
        title: "保险和PBM对账",
        description: "匹配保险理赔、裁决和DIR费用，全面的第三方付款方对账"
      },
      {
        title: "库存和销货成本跟踪",
        description: "采用FIFO/WAC成本核算的永续库存管理，仿制药与品牌药跟踪，退货/信贷处理"
      },
      {
        title: "管制物质合规",
        description: "DEA Schedule II-V对账和审计准备，详细的管制物质跟踪"
      },
      {
        title: "监管合规报告",
        description: "州委员会、DEA和FDA合规报告，自动监管费用跟踪"
      },
      {
        title: "财务分析与报告",
        description: "月度损益表、现金流分析和关键药房指标报告，支持明智决策"
      }
    ]
  },
  tracking: {
    title: "我们为您的药房跟踪的内容",
    subtitle: "我们处理每个细节，让您保持合规、随时准备审计，专注于患者护理。",
    items: [
      {
        title: "处方收入",
        description: "按付款方跟踪和核对所有处方销售和存款：现金、保险、Medicare/Medicaid"
      },
      {
        title: "非处方药销售和免疫服务",
        description: "记录前台产品和临床服务收入"
      },
      {
        title: "库存管理",
        description: "永续库存跟踪（FIFO/WAC）、仿制药与品牌药、退货/信贷"
      },
      {
        title: "管制物质",
        description: "DEA Schedule II–V对账和审计准备"
      },
      {
        title: "第三方/PBM对账",
        description: "匹配保险和PBM理赔、裁决、DIR费用"
      },
      {
        title: "应收账款",
        description: "监控保险、患者和Medicare D部分应收账款"
      },
      {
        title: "运营费用",
        description: "跟踪工资、租金、公用事业、许可证、保险和软件"
      },
      {
        title: "合规成本",
        description: "单独的监管费用（DEA、州委员会）"
      }
    ]
  },
  benefits: {
    title: "为什么药房选择LedgRkeepR",
    subtitle: "药房运营和监管合规的专业知识",
    items: [
      {
        title: "HIPAA合规专业知识",
        description: "完全符合HIPAA标准，安全数据处理和所有患者相关财务数据的审计跟踪"
      },
      {
        title: "监管知识",
        description: "深入了解DEA、FDA和州委员会要求，主动合规监控"
      },
      {
        title: "行业特定报告",
        description: "专注于药房的财务报告，包括处方量分析和付款方组合优化"
      },
      {
        title: "审计准备",
        description: "始终准备好审计，为DEA、保险和监管检查提供有组织的文档"
      }
    ]
  },
  testimonials: {
    title: "药房业主的评价",
    items: [
      {
        name: "陈莎拉博士",
        role: "社区护理药房业主",
        quote: "LedgRkeepR改变了我们的财务管理。他们的药房专业知识在我们的DEA审计中拯救了我们。",
        rating: 5
      },
      {
        name: "迈克尔·罗德里格斯药学博士",
        role: "罗德里格斯家庭药房业主",
        quote: "终于有了理解PBM对账和管制物质跟踪的记账服务。强烈推荐。",
        rating: 5
      },
      {
        name: "詹妮弗·沃尔什博士",
        role: "健康配药药房业主",
        quote: "他们符合HIPAA的流程和监管专业知识让我完全安心。",
        rating: 5
      }
    ]
  },
  cta: {
    title: "准备好简化您药房的财务管理了吗？",
    subtitle: "加入数百位信任LedgRkeepR满足其财务需求的药房业主",
    primaryButton: "预约免费咨询",
    secondaryButton: "下载药房指南"
  }
};